import React from 'react';

interface SearchBarProps {
  query: string;
  onQueryChange: (q: string) => void;
  onSearch: (q: string) => void;
  onClear: () => void;
  activeFilterCount: number;
  filterBarExpanded: boolean;
  onFilterToggle: () => void;
}

export default function SearchBar({
  query,
  onQueryChange,
  onSearch,
  onClear,
  activeFilterCount,
  onFilterToggle,
}: SearchBarProps): React.ReactElement {
  function handleKeyDown(e: React.KeyboardEvent<HTMLInputElement>): void {
    if (e.key === 'Enter') {
      onSearch(query);
    } else if (e.key === 'Escape') {
      onClear();
    }
  }

  return (
    <div className="search-bar-container">
      <div className="search-bar-input-wrap">
        <input
          data-testid="search-symbol-input"
          aria-label="Search symbols"
          className="search-input"
          type="text"
          value={query}
          autoFocus
          placeholder="Search symbols…"
          onChange={(e) => onQueryChange(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        {query.length > 0 && (
          <button
            type="button"
            className="search-clear-btn"
            aria-label="Clear search"
            onClick={onClear}
          >
            ×
          </button>
        )}
      </div>
      <button
        type="button"
        className="filters-toggle-btn"
        aria-label={`Filters (${activeFilterCount})`}
        onClick={onFilterToggle}
      >
        Filters {activeFilterCount > 0 ? `(${activeFilterCount})` : ''}
      </button>
    </div>
  );
}
